import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getMenuExpedientes, limpiarFiltrosExpedientes } from '../../actions/expedientes'
import Spinner from '../layout/Spinner'
import ExpedienteDetalle from './ExpedienteDetalle'
import ExpedientesListado from './ExpedientesListado'
import ExpedientesMenu from './ExpedientesMenu'
import NuevoExpediente from './NuevoExpediente'

const Expedientes = () => {
  const dispatch = useDispatch()

  const tipos_expedientes = useSelector(state => state.expedientes.tipos_expedientes)
  const expedientes = useSelector(state => state.expedientes.expedientes)
  const expedientes_loading = useSelector(state => state.expedientes.isLoading)
  const expediente_seleccionado = useSelector(state => state.expedientes.expediente_seleccionado)
  const tipo_expediente_seleccionado = useSelector(
    state => state.expedientes.tipo_expediente_seleccionado,
  )

  useEffect(() => {
    window.wookie()

    if (tipos_expedientes?.length === 0 && !expedientes_loading) {
      dispatch(getMenuExpedientes())
    }
    return () => {
      dispatch(limpiarFiltrosExpedientes())
    }
  }, [])

  const devolverContenido = () => {
    if (expedientes_loading && !tipo_expediente_seleccionado) {
      return <Spinner showSpinner={expedientes_loading} />
    } else if (
      expedientes &&
      tipo_expediente_seleccionado !== '' &&
      expediente_seleccionado === ''
    ) {
      return <ExpedientesListado />
    } else if (
      expedientes &&
      tipo_expediente_seleccionado !== '' &&
      expediente_seleccionado !== ''
    ) {
      if (expediente_seleccionado === 'new') {
        return <NuevoExpediente origen={tipos_expedientes[tipo_expediente_seleccionado].nombre} />
      } else {
        return <ExpedienteDetalle />
      }
    }
  }

  return (
    <div style={{ width: '100%' }}>
      <ExpedientesMenu />
      <div className='container contenedor_expedientes'>{devolverContenido()}</div>
    </div>
  )
}

export default Expedientes
